
import { createReducer, on } from '@ngrx/store';
import { UpdateState } from '../../models/update-state';
import * as updateActions from './update.actions';

export const updateActivityKey = 'updateActivity';

export const initialState: UpdateState = {
    eventUpdate: {
        assistants: 0,
        currentState: 0,
        id: 0,
        idCenter: 0,
        idStaff: 0,
        observation: ''
    },
    idTaskService: 0,
    isLoaded: false,
    isLoading: false,
    isValidate: false,
    isCancel: false,
    description: ''
};

export const updateActivtyReducer = createReducer(
    initialState,
    on(updateActions.removeTask, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.removeTaskSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: false,
        isCancel: true
    })),

    on(updateActions.removeService, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.removeServiceSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: false,
        isCancel: true
    })),
    on(updateActions.validateTask, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.validateTaskSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: true,
        isCancel: false,
    })),
    on(updateActions.validateService, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: true
    })),
    on(updateActions.validateServiceSuccess, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        isValidate: true,
        isCancel: false,
    })),
    on(updateActions.resetUpdateSchedule, (state) => ({
        ...state,
        isLoaded: false,
        isLoading: false,
        isValidate: false,
        isCancel: false,
    }))
);
